import React, { useState, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom";
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//cookie
import { setCookie } from 'src/webapp/config/cookie';
//style
import styles from 'src/asset/scss/style/user.login.module.scss';
//store
import useComnStore from 'src/webapp/stores/comn.store';
//hook
import useComnHook from 'src/webapp/hooks/comn/comn.hook';
import useRefreshAccessTokenHook from 'src/webapp/hooks/useRefreshAccessTokenHook';
//comp-wrapper
import Section from 'src/webapp/views/wrapper/Section';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
import Element from 'src/webapp/views/wrapper/Element';
//comp
import ButtonArea from '../comn/ButtonArea';//버튼영역
import TitleBar from '../comn/TitleBar';//상단타이틀바

export default function Login() {
	const { axiosPostHandler } = useAxiosHook();//axios
	const navigator = useNavigate();//navigator
	const { setMessage } = useComnStore();//결과메세지
	const { partnersInfoAPI } = useRefreshAccessTokenHook();//회원정보호출
	const { refreshTokenExpires, accessTokenExpires } = useComnHook();//토큰 만료설정

	const loginRef = useRef([]);
	/* =============== 로그인버튼활성화여부 =============== */
	const [ isDisabled,setDisabled ] = useState(true);
	const onChangeHandler = (e, name) => {
		let disabled = false;		
		for(let i = 0; i < loginRef.current.length; i++) {
			if(loginRef.current[i].value.length <= 0) { disabled = true; break; }
		}
		setDisabled(disabled);
	}
	/* =============== 로그인버튼활성화여부 =============== */
	/* =============== 비밀번호input 엔터이벤트 =============== */
	const onhandleOnKeyPress = (e) => {
		if (e.key == "Enter") { loginAPI(); }//로그인API
	}
	/* =============== 비밀번호input 엔터이벤트 =============== */
	/* =============== 로그인API =============== */
	const isLock = useRef(false);
	const loginAPI = async() => {
		if(isLock.current) { return; }

		let resMessage = '';
		isLock.current = true;
		const DATA = { PARTNER_ID:loginRef.current[0].value, PASS_WD:loginRef.current[1].value };
		const result = await axiosPostHandler(`partnerLoginForPartner.do`, DATA);
		isLock.current = false;
		if(!result) { return; }
		if(result.message == "INVALID_DATA") { console.log("데이터가 존재하지 않습니다");  }
		if(result.message == "LOGIN_FAILED") { resMessage = "정확한 로그인 정보를 입력해 주십시오"; }
		if(result.message == "WAITING_SIGNUP") { resMessage = "가입 승인 대기중입니다"; }
		if(result.message == "FORBIDDEN_DORMANT_OR_WITHDRAWAL_CUSTOMER") { resMessage = "접속제한 또는 탈퇴한 회원입니다"; }
		if(result.message == "NOT_REGISTERED_LISENCE") { resMessage = "구독 연장이 필요합니다."; }
		if(result.message == "NOT_REGISTERED_LISENCE" || result.message == "SUCCESS") {//정상업체&라이센스만료업체
			const accessExpires = accessTokenExpires();//엑세스토큰
			const refreshExpires = refreshTokenExpires();//리프레시토큰
			setCookie("NIDRP", result.data.REFRESH_TOKEN, { expires: refreshExpires, maxAge:(3600 * 24 * 365), path:"/" });
            setCookie("NIDAP", result.data.ACCESS_TOKEN, { expires: accessExpires, maxAge:3600, path:"/" });
			partnersInfoAPI(result.data.COMN_CD);//회원정보호출
			navigator("/dashboard", { replace: true });
		}
		if(resMessage.length > 0) { setMessage({type:2, message:resMessage}); }
	}
	/* =============== 로그인API =============== */

	return (
		<Section className={styles.loginContainer}>
			<Element tag={`div`} className={styles.wrapper}>
				<FixedPanel><ButtonArea /><TitleBar title={`로그인을 진행해주세요.`} /></FixedPanel>
				<FlickPanel>{/* 입력필드 */}
					<Element tag={`div`} className={styles.inputContainer}>
						<Element tag={`div`} className={styles.inputArea}>
							<Element tag={`label`}>아이디</Element>
							<input ref={el => (loginRef.current[0] = el)} onChange={(e) => onChangeHandler()} type="text" inputMode="normal" placeholder="아이디를 입력해주세요" />
						</Element>
						<Element tag={`div`} className={styles.inputArea}>
							<Element tag={`label`}>비밀번호</Element>
							<input ref={el => (loginRef.current[1] = el)} onChange={(e) => onChangeHandler()} onKeyDown={(e) => onhandleOnKeyPress(e)}
								type="password" inputMode="normal" placeholder="비밀번호를 입력해주세요" />
						</Element>
					</Element>
				</FlickPanel>
				<FixedPanel>
					<Element tag={`div`} className={styles.btnArea}>
						<Element tag={`button`} anyprop={(e) => loginAPI() } className={styles.submitButton} disabled={isDisabled}>로그인</Element>
						<Element tag={`div`}>
							<Link to={"/signup"} className={styles.signupButton}><span>회원가입</span></Link>
							<Element tag={`div`}>
								<Link to={"/find/id"}>아이디 찾기</Link>
								<Link to={"/find/passwd"}>비밀번호 찾기</Link>
							</Element>
						</Element>
					</Element>
				</FixedPanel>
			</Element>
		</Section>
	);
}